import React from "react";
import "./QuestionPanel.css";

interface Question {
  id: string;
  question: string;
  optionA: string;
  optionB: string;
  optionC: string;
  optionD: string;
}

interface QuestionPanelProps {
  question: Question;
  selectedOption: string;
  onOptionChange: (questionId: string, option: string) => void;
}

const QuestionPanel: React.FC<QuestionPanelProps> = ({
  question,
  selectedOption,
  onOptionChange,
}) => {
  return (
    <div className="question-panel-container">
      <div
        className="question-description"
        dangerouslySetInnerHTML={{ __html: question.question }}
      />
      <div className="options">
        {["A", "B", "C", "D"].map((opt) => (
          <div key={opt} className="option">
            <input
              type="radio"
              id={`${question.id}_${opt}`}
              name={question.id}
              value={opt}
              checked={selectedOption === opt}
              onChange={() => onOptionChange(question.id, opt)}
            />
            <label htmlFor={`${question.id}_${opt}`}>
              <span
                dangerouslySetInnerHTML={{
                  __html: question[`option${opt as "A" | "B" | "C" | "D"}`],
                }}
              />
            </label>
            {/* <label htmlFor={`${question.id}_${opt}`}>
                {question[`option${opt as "A" | "B" | "C" | "D"}`]}
            </label> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuestionPanel;
